import { IOrderAddonItem } from "interfaces";
import { convertCurrency, currencySymbol, formatNumber } from "utills/helpers";

interface AddonProductCardProps {
  data?: IOrderAddonItem[];
  orderCurrency: string;
  rate: number;
}

export const AddonProductCard = ({
  data = [],
  orderCurrency = "",
  rate,
}: AddonProductCardProps) => {
  return (
    <ul className="bg-white">
      {data.map((item: IOrderAddonItem, index: number) => (
        <div
          key={item.id ?? index}
          className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl"
        >
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">No</p>
            <p className="flex-1 text-right text-sm leading-6">{index + 1}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Addon name
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.addon_name}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Variant</p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.variant_label || "-"}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Quantity</p>
            <p className="flex-1 text-right text-sm leading-6">
              {formatNumber(item.qty ?? 0)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Unit price
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {currencySymbol()}{" "}
              {convertCurrency(item.unit_price ?? 0, orderCurrency ?? "", rate)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Subtotal</p>
            <p className="flex-1 text-right text-sm leading-6">
              {currencySymbol()}{" "}
              {convertCurrency(item.subtotal ?? 0, orderCurrency ?? "", rate)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Note</p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.note || "-"}
            </p>
          </li>
        </div>
      ))}
    </ul>
  );
};
